/**
 * Adjust 事件追踪工具函数
 * 文档: https://dev.adjust.com/zh/sdk/web/features/events
 *
 * 事件 Token：
 * - register（注册）: epjant
 * - purchase（付费）: vabg2j
 */

import { Adjust } from '@/init/adjust'

/**
 * 添加统一回传参数
 * @param {Array[Object]} params - 统一回传参数，格式为 [key: string, value: string]
 * @returns {void}
 */
export function addGlobalCallbackParameters(params) {
  return Adjust.addGlobalCallbackParameters(params)
}

/**
 * 移除统一回传参数
 * @param {string} key - 参数 key
 * @returns {void}
 */
export function removeGlobalCallbackParameter(key) {
  return Adjust.removeGlobalCallbackParameter(key)
}

/**
 * 清除统一回传参数
 * @returns {void}
 */
export function clearGlobalCallbackParameters() {
  return Adjust.clearGlobalCallbackParameters()
}

/**
 * 上报 Adjust 事件
 * @param {string} eventToken - 事件 Token
 * @param {Object} [params] - 额外参数（revenue, currency, deduplicationId 等）
 */
export function trackAdjustEvent(eventToken, params = {}) {
  if (!eventToken) {
    console.warn('[Adjust] trackAdjustEvent: eventToken is required')
    return
  }
  Adjust.trackEvent({ eventToken, ...params })
}

/**
 * 上报注册事件
 * @param {Object} [params] - 额外参数（callbackParams 等）
 */
export function trackAdjustRegister(params = {}) {
  trackAdjustEvent('epjant', params)
}

/**
 * 上报付费事件
 * @param {Object} [params] - 额外参数（revenue, currency, deduplicationId 等）
 * @param {number} [params.revenue] - 付费金额（美元）
 * @param {string} [params.currency] - 货币代码（ISO 4217，如 "USD"）
 * @param {string} [params.deduplicationId] - 去重 ID，防止重复上报（建议传订单号）
 */
export function trackAdjustPurchase(params = {}) {
  trackAdjustEvent('vabg2j', params)
}
